module.exports = "pegasus_template/assets/styleGroup3-google.png";